import React from 'react';
import {Image} from "antd";
import Locale from "../util/Locale";

function About() {
    return (
        <div className="dark:bg-gray-800 relative flex-grow">
            <div className="overflow-hidden relative">
                <section className="relative z-10 dark:bg-gray-800 bg-white ">
                    <div className="py-8 px-4 mx-auto max-w-screen-xl sm:py-16 lg:px-6">
                        <div className="font-light text-gray-700 sm:text-lg dark:text-gray-100"><h2
                            className="mb-12 text-4xl tracking-tight font-extrabold text-gray-900 dark:text-white">
                            <Locale code={'menu.about'}/>
                        </h2></div>
                        <div className="">
                            <div className="font-light text-gray-700 text-base dark:text-gray-100">
                                <Locale code={'about.description'}/>
                            </div>
                        </div>
                    </div>
                </section>
                <div>
                    <div>
                        <section className="pb-4 lg:rotate-[8deg] bg-gray-200 dark:bg-gray-700">
                            <div className="px-4 mx-auto max-w-screen-xl sm:pb-32 pt-12 lg:px-6 lg:-rotate-[8deg]">
                                <div className="text-gray-700 dark:text-gray-100">
                                    <div className="sm:w-[256px] mb-5 w-full float-left mr-8">
                                        <Image preview={false} alt="working" className="w-full rounded-lg" src="/images/profile/hajduk.jpeg?v=1"/>
                                    </div>
                                    <Locale code={'about.hajduk'}/>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div>
                        <section className="pb-4 lg:rotate-[8deg]">
                            <div className="px-4 mx-auto max-w-screen-xl sm:pb-32 pt-12 lg:px-6 lg:-rotate-[8deg]">
                                <div className="text-gray-700 dark:text-gray-100">
                                    <div className="sm:w-[256px] mb-5 w-full float-right ml-8">
                                        <Image preview={false} alt="working" className="w-full rounded-lg" src="/images/profile/marton.jpeg?v=1"/>
                                    </div>
                                    <Locale code={'about.marton'}/>
                                </div>
                            </div>
                        </section>
                    </div>
                    <div>
                        <section className="pb-4 lg:rotate-[8deg] bg-gray-200 dark:bg-gray-700">
                            <div className="px-4 mx-auto max-w-screen-xl sm:pb-32 pt-12 lg:px-6 lg:-rotate-[8deg]">
                                <div className="text-gray-700 dark:text-gray-100">
                                    <div className="sm:w-[256px] mb-5 w-full float-left mr-8">
                                        <Image preview={false} alt="working" className="w-full rounded-lg" src="/images/profile/jevcik.jpeg?v=1"/>
                                    </div>
                                    <Locale code={'about.jevcik'}/>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;
